module.exports = __webpack_public_path__ + "static/media/img_profile_breakdown.f5fd1438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_profile_breakdown.png
// module id = 109
// module chunks = 0